import React, { useEffect, useState } from 'react';

import { Button, ConfigProvider, Modal } from 'antd';
import './index.css';
import { buryingPoint, EventName } from '../../utils/buryingPoint';

const CacheKey = 'PromotionMessage';

const PromotionModal = () => {
  const initOpen = localStorage.getItem(CacheKey) === 'hidden' ? false : true;

  const [open, setOpen] = useState(initOpen);
  const [imgOpen, setImgOpen] = useState(false);

  useEffect(() => {
    const promotionTips = localStorage.getItem(CacheKey);
    if (promotionTips !== 'hidden') {
      buryingPoint({
        t: 'expose',
        name: EventName.Modal,
      });
    }
  }, []);

  const onView = () => {
    window.open('https://lingowhale.com/home', '_blank');
  };

  const onNotTips = () => {
    setOpen(false);
    localStorage.setItem(CacheKey, 'hidden');

    buryingPoint({
      t: 'click',
      name: EventName.Modal_NotTips,
    });
  };

  const onClose = () => {
    setOpen(false);

    buryingPoint({
      t: 'click',
      name: EventName.Modal_Close,
    });
  };

  const onOpenQRcode = () => {
    let device = '';
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
      device = 'IOS';
    } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
      device = 'Android';
    } else {
      device = 'PC';
    };

    if (device === 'PC') {
      setImgOpen(true);
    } else {
      window.open('https://h5.lingowhale.com/?channel=shenyandayi-homepage', '_blank');
    }
  }

  if (!open) return null;

  return (
    <ConfigProvider theme={{ token: {} }}>
      <Modal
        title=""
        maskClosable={false}
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        footer={null}
        bodyStyle={{ padding: 0 }}
        width={620}
        zIndex={9900}
        className="promotion-modal"
      >
        <div>
          <img
            src="https://deeplang-frontend.oss-cn-zhangjiakou.aliyuncs.com/shenyan-dayi/mYvIhGnArY-AXul8S33nm.jpeg"
            alt=""
            className="promotion-modal__img"
          />
        </div>
        <div className="promotion-modal__content">
          <h2>给老朋友的新产品 —— 语鲸 🐳</h2>
          <div>
            <p>亲爱的用户，</p>
            <p>
              和大家说个好消息，我们研发的新产品
              <span className="lingo-whale">「语鲸」</span>
              已经正式发布 🎉
            </p>
            <p>
              它的目标是成为让你<span>10倍提效的个性化信息助手</span>。你可以用它<span>订阅你感兴趣的话题</span>
              （比如“最新的AI产品”），让它从指定网站、公众号追踪相关文章；你也可以用它的<span>AI聚合和总结</span>
              功能1分钟尽览你关心的热点，5分钟看完万字长文。
            </p>
            <p>我们希望有了语鲸，你能用更少的时间获取更多对自己有用的信息，轻松应对新一轮信息爆炸，高效提升认知。</p>
            <p>语鲸APP当前完全免费，扫描下方二维码或在各大应用商店搜索“语鲸”即可下载。欢迎老朋友们体验！</p>
          </div>

          <div className="promotion-modal__footer">
            <div className="promotion-modal__qrcode" onClick={onOpenQRcode}>
              <img
                src="https://deeplang-frontend.oss-cn-zhangjiakou.aliyuncs.com/shenyan-dayi/DlBLh9wVCgXNWHFtWFL8t.jpeg"
                alt=""
              />
              <span>扫码下载语鲸APP</span>
            </div>

            <div className="promotion-modal__footer-right">
              <Button type="text" className="promotion-modal__footer-btn" onClick={onNotTips}>
                不再提醒
              </Button>
              <Button type="primary" className="promotion-modal__footer-btn" onClick={onClose}>
                关闭窗口
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title=""
        centered
        open={imgOpen}
        onOk={() => setImgOpen(false)}
        onCancel={() => setImgOpen(false)}
        footer={null}
        closable={false}
        width={490}
        bodyStyle={{ padding: 0 }}
        zIndex={9999}
        className='promotion-modal'
      >
        <img
          src="https://deeplang-frontend.oss-cn-zhangjiakou.aliyuncs.com/shenyan-dayi/DlBLh9wVCgXNWHFtWFL8t.jpeg"
          alt=""
        />
      </Modal>
    </ConfigProvider>
  );
};

export default PromotionModal;
